export default "__VITE_ASSET__B8MzoEA7__"